import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { NextRacesState, RaceSportType } from './NextRaces.state';
import { NextRacesSlider } from './racesSlider/NextRacesSlider';
import { NextRacesSportPageHeader } from './NextRacesHeader';
import { RacesSliderSection } from './racesSlider/NextRacesSlider.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface NextRacesSportPagePropsType {
    nextRacesState: NextRacesState;
    sport: RaceSportType;
}
export const NextRacesSportPage = observer('NextRacesSportPage', (props: NextRacesSportPagePropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { nextRacesState, sport } = props;

    return (
        <RacesSliderSection variant={configState.componentVariants.sportsbookVariant}>
            <NextRacesSportPageHeader
                nextRacesState={nextRacesState}
                sport={sport}
            />
            <NextRacesSlider nextRacesState={nextRacesState} />
        </RacesSliderSection>
    );
});
